import React from 'react';
import { Route } from 'react-router-dom';

import Login from './pages/login';

function SignRoutes() {
 return (
    <Route exact path="/" component={Login} />
 );
};

export default SignRoutes;